export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};
export const NAV = {
  W_DASHBOARD: 104,
};
export const DRAWER = {
  W_CREATOR_DETAILS: 602,
};
export const ICON = {
  NAV_ITEM: 24,
};
